// extracted by mini-css-extract-plugin
export default {"signupBanner":"HomePageShowcase_signupBanner__P+iXf"};